module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetHigh.62205d5.jpg";